import(/* webpackMode: "eager" */ "/opt/render/project/src/components/animation/AnimatedDiv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/languages/LanguageSwitcherSelect.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/layouts/AnimatedPageHeaderImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/navBar/FixedNavBarDesktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/navBar/NavBarItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/navBar/NavBarMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/navBar/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/ToasterProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/ToggleTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/containers/newsletter/NewsLetterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/local/target.css?{\"path\":\"components/fonts.ts\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-primary\",\"src\":[{\"path\":\"../public/fonts/Poppins/Poppins-SemiBold.ttf\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"../public/fonts/Poppins/Poppins-Bold.ttf\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../public/fonts/Poppins/Poppins-Medium.ttf\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../public/fonts/Poppins/Poppins-Regular.ttf\",\"weight\":\"400\",\"style\":\"normal\"}]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/local/target.css?{\"path\":\"components/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/fonts/Calibre/Calibre-Bold.otf\",\"variable\":\"--font-secondary\",\"weight\":\"600\"}],\"variableName\":\"secondaryFontFiles\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/opt/render/project/src/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/react-wrap-balancer/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/tiptap-parser/dist/esm/components/CodeBlockWithCopy.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/tiptap-parser/dist/esm/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/providers/ThemeProvider.tsx");
